import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
} from "mdb-react-ui-kit";
import logo from "../assets/img/logo.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/nav-icon4.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
        </Row>
      </Container>
      <MDBFooter
        bgColor="light"
        className="text-center text-lg-start text-muted"
      >
        <section className="">
          <MDBContainer className="text-center text-md-start mt-1 pt-2">
            <MDBRow className="mt-3">
              <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">
                  <MDBIcon className="" />
                  <img src={logo} style={{ width: "76%" }} alt="logo" />
                </h6>
                <p>
                  The one-stop-shop for organizational learning: <br></br>
                  From IDEA to LEARNING SUCCESS!
                </p>
                <div className="social-icon mx-auto">
                  <a
                    href="https://www.linkedin.com/showcase/epistum-cloud/?viewAsMember=true"
                    target="_blank"
                  >
                    <img src={navIcon1} alt="Icon" />
                  </a>
                  <a
                    href="https://www.facebook.com/people/Epistum/100086978004302/"
                    target="_blank"
                  >
                    <img src={navIcon2} alt="Icon" />
                  </a>
                  <a
                    href="https://www.youtube.com/@epistumlms6103"
                    target="_blank"
                  >
                    <img src={navIcon3} alt="Icon" />
                  </a>
                  <a
                    href="https://www.instagram.com/epistum_cloud/"
                    target="_blank"
                  >
                    <img src={navIcon4} alt="instagram" />
                  </a>
                </div>
              </MDBCol>

              <MDBCol md="2" lg="2" xl="2" className="mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Products</h6>
                <p>
                  <a
                    href="https://epistum.com/e-course-development"
                    target="_blank"
                    className="text-reset"
                  >
                    E-Course Development
                  </a>
                </p>
                <p>
                  <a
                    href="https://epistum.com/learning-platforms/"
                    target="_blank"
                    className="text-reset"
                  >
                    Learning Platforms
                  </a>
                </p>
                <p>
                  <a
                    href="https://epistum.com/mobile-web-app-development/"
                    target="_blank"
                    className="text-reset"
                  >
                    Mobile & Web App Development
                  </a>
                </p>
                <p>
                  <a
                    href="https://epistum.com/virtual-and-augmented/"
                    target="_blank"
                    className="text-reset"
                  >
                    Virtual & Augmented Reality
                  </a>
                </p>
              </MDBCol>

              <MDBCol md="3" lg="2" xl="2" className="mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Useful links</h6>
                <p>
                  <a
                    href="https://epistum.com/animated-videos/"
                    target="_blank"
                    className="text-reset"
                  >
                    Animated Videos
                  </a>
                </p>
                <p>
                  <a
                    href="https://ivote.mk/?page_id=28"
                    target="_blank"
                    className="text-reset"
                  >
                    Elections Software
                  </a>
                </p>
                <p>
                  <a
                    href="https://epistum.com/mobile-web-app-development/"
                    target="_blank"
                    className="text-reset"
                  >
                    Web development
                  </a>
                </p>
                <p>
                  <a
                    href="https://epistum.com/privacy-policy/"
                    target="_blank"
                    className="text-reset"
                  >
                    Privacy policy
                  </a>
                </p>
                <p>
                  <a
                    href="https://epistum.com/terms-condition/"
                    target="_blank"
                    className="text-reset"
                  >
                    Terms & Conditions
                  </a>
                </p>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>

        <div
          className="text-center p-4"
          style={{ color: "#fff", backgroundColor: "#22b6a1" }}
        >
          Copyright Epistum © 2023. All Rights Reserved
        </div>
      </MDBFooter>
    </footer>
  );
};
